function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 188 97",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-headphones",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 74.014 61.838 L 74.014 48.514 C 74.014 33.13 90.668 23.515 103.992 31.207 C 110.176 34.778 113.985 41.375 113.985 48.514 L 113.985 61.838",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.985 64.059 C 113.985 66.512 111.997 68.5 109.544 68.5 L 107.323 68.5 C 104.869 68.5 102.882 66.512 102.882 64.059 L 102.882 57.397 C 102.882 54.945 104.869 52.956 107.323 52.956 L 113.985 52.956 Z M 74.014 64.059 C 74.014 66.512 76.001 68.5 78.455 68.5 L 80.676 68.5 C 83.13 68.5 85.117 66.512 85.117 64.059 L 85.117 57.397 C 85.117 54.945 83.13 52.956 80.676 52.956 L 74.014 52.956 Z",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.6a7d5687c7c1355e01d20b740f7fb2b1.svg";
export { ForwardRef as ReactComponent };